import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../hooks/useLocalizedPath';

const SITE_URL = 'https://www.finmaple.com';

const BreadcrumbNav = ({ items }) => {
  const { t, i18n } = useTranslation();
  const lp = useLocalizedPath();
  const lng = i18n.language;
  const homeLabel = t('breadcrumb.home');
  const homeUrl = `${SITE_URL}/${lng}/`;

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: homeLabel,
        item: homeUrl,
      },
      ...items.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 2,
        name: item.label,
        ...(item.to ? { item: `${SITE_URL}${item.to}` } : {}),
      })),
    ],
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <Breadcrumbs
        separator={<NavigateNextIcon sx={{ fontSize: 16, color: '#78909C' }} />}
        sx={{ '& .MuiBreadcrumbs-li': { fontSize: '0.875rem' } }}
      >
        <Link
          component={RouterLink}
          to={lp('home')}
          underline="hover"
          sx={{ color: '#1E3A5F', fontWeight: 500 }}
        >
          {homeLabel}
        </Link>
        {items.map((item, index) =>
          index < items.length - 1 ? (
            <Link
              key={index}
              component={RouterLink}
              to={item.to}
              underline="hover"
              sx={{ color: '#1E3A5F', fontWeight: 500 }}
            >
              {item.label}
            </Link>
          ) : (
            <Typography key={index} sx={{ color: '#78909C', fontWeight: 500, fontSize: '0.875rem' }}>
              {item.label}
            </Typography>
          )
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbNav;
